/* * * VUE.JS 2.5+ component files * * */

module.exports = ( Vue ) => { 

  	Vue.prototype.notify = function( code ) {

        switch( code ) {

            case 'save-success' : $.notify('Промените бяха успешни','success'); break;


        }

    };



}